import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';
import { header, titles } from '../../../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {},
	confirmationContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		padding: '24px 0',
	},
	icon: {
		marginBottom: 20,
	},
	header: {
		fontSize: 24,
		fontWeight: 600,
		marginBottom: 16,
	},
	message: {
		fontSize: 16,
		lineHeight: '1.5',
		color: header,
	},
	responseDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		width: '100%',
		alignItems: 'flex-start',
		maxWidth: 600,
		margin: '0 auto',
	},
	detailsHeader: {
		fontSize: 16,
		fontWeight: 600,
		marginBottom: 8,
	},
	detailItem: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		maxWidth: 600,
		textAlign: 'left',
		marginBottom: 16,
		...CssSelectors.allDescendants(
			{
				display: 'flex',
			},
			'span'
		),
	},
	detailLabel: {
		fontSize: 14,
		fontWeight: 600,
		color: header,
	},
	customProperties: {
		margin: '16px 0',
	},
	customPropertiesHeader: {
		fontSize: 16,
		fontWeight: 600,
		marginBottom: 8,
		textAlign: 'left',
	},
	actionContainer: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	thankYouContent: {
		fontSize: 14,
		maxWidth: 600,
		margin: '12px auto',
		color: titles,
		textAlign: 'left',
	},
	addressDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		alignItems: 'flex-start',
	},
	fileName: {
		paddingBlock: THEME.spacing.xs,
	},
});
